module.exports = "<i class=\"icon-group\"></i> {{ contact_group.name }}\n"